import { useState, useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import './signiteTextArea.css';
import { useFormikContext } from 'formik';
const SigniteTextArea = (props) => {
  const {
    id,
    label,
    className,
    style,
    rowSpan,
    maxCount = 250,
    name,
    value,
  } = props;

  const { setFieldValue, handleBlur, values } = useFormikContext();

  const sanitizeValue = (val) => {
    if (Array.isArray(val)) return val.join(', ');
    if (val === null || val === undefined) return '';
    return val;
  };

  const [text, setText] = useState(sanitizeValue(value));
  const [charCount, setCharCount] = useState(sanitizeValue(value).length);
  const [wordCount, setWordCount] = useState(0);
  const [inFocus, setInFocus] = useState(false);

  const countWords = (text) => {
    return text.trim().split(/\s+/).filter(Boolean).length;
  };

  useEffect(() => {
    const sanitized = sanitizeValue(value);
    setText(sanitized);
    setCharCount(sanitized.length);
    setWordCount(countWords(sanitized));
  }, [value]);

  const handleChange = (e) => {
    let inputText = e.target.value;

    if (Array.isArray(inputText)) {
      inputText = inputText.join(', ');
    }

    const words = countWords(inputText);

    if (words <= maxCount) {
      setText(inputText);
      setWordCount(words);
      setCharCount(inputText.length);
      setFieldValue(name, inputText); 
    }
  };

  const handleFieldBlur = (e) => {
    handleBlur(e); 
    setInFocus(false);
  };

  return (
    <Form.Group as={Col} controlId={id}>
      <Form.Label>{label}</Form.Label>
      <div className={`ta-wrapper char-count ${inFocus ? 'focused' : ''} ${className || ''}`}>
        <Form.Control
          name={name}
          as="textarea"
          value={text}
          rows={rowSpan}
          style={style ? style : null}
          onChange={handleChange}
          onFocus={() => setInFocus(true)}
          onBlur={handleFieldBlur}
        />
        <Form.Label className="char-count">
          {wordCount}/{maxCount} words
        </Form.Label>
      </div>
    </Form.Group>
  );
};

export default SigniteTextArea;
